import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/storage');

export const getStorageErrors = actionCreator.async<{}, {}>('GET_STORAGE_ERRORS');
